<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between px-6" [ngClass]="shortScreen ? 'pt-3 pb-2' : 'pt-6 pb-4'">
    <div class="flex items-start gap-2">
      <mat-icon class="text-primary mt-1">receipt_long</mat-icon>
      <div>
        <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.ORDER_ITEMS_MODAL.TITLE' | t }}</h2>
        @if (!shortScreen) {
        <div class="text-secondary text-sm">
          {{ 'DOCUMENT_GENERATE.ORDER_ITEMS_MODAL.CLIENT_LABEL' | t }}
          <span class="text-primary font-medium">
            @if (data.clientCode) { {{ data.clientCode }} - }{{ data.clientName || '-' }}
          </span>
        </div>
        }
      </div>
    </div>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- tabla de artículos (misma que el formulario) -->
  <div class="flex min-h-0 flex-1 flex-col overflow-hidden border-t px-6 pt-4">
    <app-items-table
      #tbl
      class="flex min-h-0 flex-1 flex-col"
      [items]="data.items"
      [embedded]="true"
      [canAdd]="data.canAdd ?? true"
      [editablePrice]="data.editablePrice ?? false"
      [taxIncluded]="data.taxIncluded ?? false"
      [compact]="dgConfig.isCompactScreen"
      [allowMultipleWarehouses]="data.allowMultipleWarehouses ?? false"
      [splitsByWarehouse]="data.splitsByWarehouse ?? false"
      (add)="data.onAdd?.($event)"
      (changeUnit)="data.onChangeUnit?.($event)"
      (quantityChange)="data.onQuantityChange?.($event)"
      (priceChange)="data.onPriceChange?.($event)"
      (openCalculator)="data.onCalculate?.($event)"
      (openDetail)="data.onDetail?.($event)"
      (openWarehouses)="data.onWarehouses?.($event)"
      (remove)="data.onRemove?.($event)">
    </app-items-table>
  </div>

  <!-- footer -->
  <div class="flex flex-col items-start justify-between gap-4 border-t px-6 sm:flex-row sm:items-center"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <div class="flex flex-wrap gap-x-8 gap-y-2">
      <div class="flex flex-col">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ORDER_ITEMS_MODAL.TOTAL_LINES' | t }}</span>
        <span class="text-primary font-semibold">{{ 'DOCUMENT_GENERATE.ORDER_ITEMS_MODAL.LINES_COUNT' | t: { count: data.items.length } }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.TOTALS.SUBTOTAL' | t }}</span>
        <span class="font-semibold">L.&nbsp;{{ totalSubtotal | dgNumber }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.TOTALS.DISCOUNT' | t }}</span>
        <span class="font-semibold">L.&nbsp;{{ totalDiscount | dgNumber }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.TOTALS.TAX' | t }}</span>
        <span class="font-semibold">L.&nbsp;{{ totalIsv | dgNumber }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.TOTALS.TOTAL' | t }}</span>
        <span class="text-primary font-semibold">L.&nbsp;{{ montoTotal | dgNumber }}</span>
      </div>
    </div>
    <div class="flex items-center gap-3">
      @if (tbl.selected.size) {
      <button mat-stroked-button color="warn" type="button" (click)="tbl.removeSelected()">
        <mat-icon>delete</mat-icon>
        {{ 'DOCUMENT_GENERATE.ORDER_ITEMS_MODAL.DELETE_SELECTED' | t: { count: tbl.selected.size } }}
      </button>
      }
      <button mat-flat-button color="primary" type="button" (click)="close()">{{ 'GENERAL.CLOSE' | t }}</button>
    </div>
  </div>
</div>
